export const Constants = {
    webUrl: process.env.REACT_APP_WEB_URL ?? "",
    frankenstoriesUrl: process.env.REACT_APP_FRANKENSTORIES_URL ?? "",
    gtm: process.env.REACT_APP_GTM_FRANKENSTORIES ?? "",
};
